// locationDB.js
import {openDB} from 'idb';

const DB_NAME = 'crm-sikido-db';

const DB_VERSION = 2;

export const initDB = async () => {
    return await openDB(DB_NAME, DB_VERSION, {
        upgrade(db, oldVersion, newVersion)
        {
            if (db.objectStoreNames.contains('districts'))
            {
                db.deleteObjectStore('districts');
            }

            // Tạo lại các store nếu chưa có
            if (!db.objectStoreNames.contains('provinces'))
            {
                db.createObjectStore('provinces', { keyPath: 'id' });
            }

            if (!db.objectStoreNames.contains('wards'))
            {
                db.createObjectStore('wards', { keyPath: 'id' });
            }
        }
    });
};

export const isLocationCached = async () => {
    const db = await initDB();
    const [pc, wc] = await Promise.all([
        db.count('provinces'),
        db.count('wards'),
    ]);
    return pc > 0 && wc > 0;
};

export const saveProvinces = async (list) => {
    const db = await initDB();
    const tx = db.transaction('provinces', 'readwrite');
    list.forEach(item => tx.store.put(item));
    await tx.done;
};

export const saveWards = async (list) => {
    const db = await initDB();
    const tx = db.transaction('wards', 'readwrite');
    list.forEach(item => tx.store.put(item));
    await tx.done;
};

export const getAllProvinces = async () => {
    const db = await initDB();
    return await db.getAll('provinces');
};

export const getWardsByProvince = async (provinceId) => {
    const db = await initDB();
    return (await db.getAll('wards')).filter(w => w.province_id === provinceId);
};

export const getProvinceById = async (provinceId) => {
    const db = await initDB();
    return await db.get('provinces', provinceId);
};

export const getWardById = async (wardId) => {
    const db = await initDB();
    return await db.get('wards', wardId);
};
